<template>
  <div class="zy-home-page">
    <!-- banner图 start -->
    <div class="banner-wrap">
      <div class="banner-img">
        <img :src="item" alt="" v-for="(item ,index) in bannerImg" :key="index">
      </div>
    </div>
    <!-- banner图 end -->

    <!-- 分类展示部分 start -->
    <div class="main-content w">
      <div class="main-content-item" v-for="(item, index) in mainContentList" :key="index">
        <div class="main-content-item-container">
          <div class="title">{{item.title}}</div>
          <div class="main-img">
            <img :src="item.url" alt="">
          </div>
        </div>
      </div>
    </div>
    <!-- 分类展示部分 end -->
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  data () {
    return {
      // banner图数据
      bannerImg: ['img/Home/banner.png'],
      // 中间内容部分数据
      mainContentList: [
        {
          title: '服务行业',
          url: 'img/Home/service.png'
        },
        {
          title: '全公司数字化能力',
          url: 'img/Home/digitization.png'
        },
        {
          title: '全业务支撑能力',
          url: 'img/Home/business.png'
        }
      ]
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.zy-home-page {
  width: 100%;
  background-color: $bgcolor-main;
  user-select: none;
  // padding-top: 64px;
  // banner图 start
  .banner-wrap {
    width: 1600px;
    height: auto;
    .banner-img {
      width: 1600px;
      height: auto;
      margin: 0 auto;
      img {
        width: 1600px;
      }
    }
  }
  // banner图 end

  // 分类展示部分 start
  .main-content {
    .main-content-item {
      padding-top: 60px;
      .main-content-item-container {
        width: 100%;
        height: auto;
        .title {
          padding-left: 16px;
          position: relative;
          margin-bottom: 30px;
          line-height: 28px;
          font-size: $fontsize-main;
          font-weight: $fontweight-highlight;
          color: $fontcolor-main;
        }
        .title::before {
          content: "";
          width: 6px;
          height: 26px;
          background-color: $bgcolor-theme;
          position: absolute;
          left: 0;
          bottom: 0;
        }
        .main-img {
          width: 100%;
          height: auto;
          img {
            width: 1200px;
          }
        }
      }
    }
    .main-content-item:last-child {
      padding-bottom: 112px;
    }
  }
  // 分类展示部分 end
}
</style>
